import { Controller } from 'react-hook-form';

import { DatePicker } from '#src/components/DatePicker/DatePicker.tsx';

export const ResolvedDate = () => (
  <Controller
    name="resolvedDate"
    rules={{
      validate: (value: string) => {
        if (new Date(value) > new Date()) {
          return 'Provide a date and time in the past.';
        }
      },
    }}
    render={({ field }) => (
      <DatePicker
        name="security-breach-resolved-date"
        type="datetime-local"
        onChange={(_, date) => field.onChange(date?.toISOString() ?? '')}
        value={field.value}
        max={new Date()}
        label="If resolved, when was the incident resolved?"
        secondaryLabel="Optional"
      />
    )}
  />
);
